(function(){
    class ActivityCard{
    
        constructor() {
            this.elements = document.querySelectorAll('button[data-action=activity-details-toggle')
            
            for (const item of this.elements) {
                const outerContainer = item.parentElement.parentElement;
                const contentContainer = outerContainer.querySelector('.location-details');
                const spacer = outerContainer.querySelector('.top-spacer');
                const chevronUp = item.querySelector('.chevron-up');
                const chevronDown = item.querySelector('.chevron-down');
                let contentHeight = contentContainer.scrollHeight;
                const classList = outerContainer.classList
    
                if (classList.contains("open")) {
                    contentContainer.style.setProperty("max-height", contentHeight + 'px');
                    spacer.style.setProperty("max-height", '30px');
                }
    
                item.addEventListener('click', (ev) => {
                    if(classList.contains("open")){
                        classList.remove("open")
                        contentContainer.style.setProperty("max-height", '0px');
                        spacer.style.setProperty("max-height", '0px');
                        chevronDown.classList.remove("hide");
                        chevronUp.classList.add("hide");
                        if(item.parentElement.classList.contains("details-toggle-sm")){
                            item.querySelector("span").innerHTML = "More"
                        }else{
                            item.querySelector("span").innerHTML = "More Details"
                        }
                    }else{
                        classList.add("open")
                        contentContainer.style.setProperty("max-height", contentHeight + 'px');
                        spacer.style.setProperty("max-height", '30px');
                        chevronDown.classList.add("hide");
                        chevronUp.classList.remove("hide");
                        if(item.parentElement.classList.contains("details-toggle-sm")){
                            item.querySelector("span").innerHTML = "Less"
                        }else{
                            item.querySelector("span").innerHTML = "Less Details"
                        }
    
                    }
                })
            }
        }
    }
    
    new ActivityCard();
})()    

